import React from 'react'
import classnames from 'classnames'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Banner = ({ page }) => {
  const location = useLocation()

  const { showBannerOnStartpage } = useSelector((state) => state.app.appSettings)

  if (location.pathname === '/' && !showBannerOnStartpage) return null

  return (
    <div
      className={classnames('banner', { 'is-start': location.pathname === '/' })}
      style={{ backgroundImage: page.headerImage && `url(/images/${page.headerImage})` }}
    >
      {location.pathname === '/' ? (
        <>
          <div className="welcome-bubble">{__.trans('start.welcome')}</div>
          <div className="ready-bubble">
            <span>{__.trans('start.thanks-for-giving')}</span>
          </div>
        </>
      ) : (
        <h2>{page.headerText}</h2>
      )}
    </div>
  )
}

export default Banner
